import {KostStateType} from 'module/Kost/reducer/KostReducer';
import {selPropGenString} from 'module/Properties/selector/selPropGen'
import {PropID} from 'module/Properties/enum/PropID'
import {createSelector} from 'reselect'

export const selKostById = (state: KostStateType) => state.Kost.byId
export const selKostAllIds = (state: KostStateType) => state.Kost.allIds
export const selKostVisibleIds = (state: KostStateType) => state.Kost?.visibleIds || []
export const selKostFetched = (state: KostStateType) => state.Kost.fetched
export const selKostLoading = (state: KostStateType) => state.Kost.loading
export const selKostModelsActive = createSelector(
	selKostById,
	selKostVisibleIds,
	selKostAllIds,
	(byId, visibleIds, allIds) =>
		(visibleIds.length ? visibleIds : allIds).flatMap(k => {
			const m = byId[k]
			if (m) return [m]
			return []
		}),
)

export const selKostString = selPropGenString(PropID.textKost, 'Kostenstelle')